import React from "react";
import "./Hero.css";
// --- UI/UX UPGRADE: Import a professional icon ---
import { FiArrowRight } from "react-icons/fi";

const Hero = () => {
  return (
    <div className="hero">
      {/* A dark overlay to make the text pop */}
      <div className="hero-overlay"></div>
      
      <div className="hero-content container">
        {/* The "eyebrow" text to introduce the brand */}
        {/* <h2>MADURAI SPECIAL</h2> */}
        
        {/* The main, powerful headline */}
        <h1>Free Aama Vada<br />(With Every Order)</h1>
        
        {/* Supporting text with more detail */}
        <p>Hot dosas, idlis, and more, brought straight to your hostel doorstep.Because You Deserve the Best</p>
        
        {/* A clear, unmissable Call-to-Action button */}
        {/* This is an anchor link that will scroll the user down to the menu section */}
        <a href="#menu-section" className="hero-cta-btn">
          <span>Order Now</span>
          <FiArrowRight size={22} />
        </a>
      </div>
    </div>
  );
};

export default Hero;